module.exports = __webpack_public_path__ + "img/loadingImage.b0b7757d.gif";